import { memo } from "react";
import { TemplatePage } from "../../0_TemplatePage/TemplatePage";
import ProfileContent from "./ProfileComponents/ProfileContent";

function ProfilePage() {
  return (
    <div className="content" sx={{ clear: "left" }}>
      <TemplatePage type={"profile"}>
        <ProfileContent />
      </TemplatePage>
    </div>
  );
}

export default memo(ProfilePage);
